<template>
  <div class="categoriesWithListGrid">
    <div class="categoriesWithListGrid__items">
      <div
        class="categoriesWithListGrid__itemsItem"
        v-for="(childCat, childCatIndex) in items"
        :key="childCatIndex"
      >
        <info-small-tile center-content class="">
          <nuxt-link
            :to="
              localePath({
                name: 'category-slug',
                params: { slug: childCat.slug },
              })
            "
            class="categoriesWithListGrid__tileWrapperLink"
          />
          <div class="categoriesWithListGrid__tileImageWrapper">
            <new-image-box
              v-if="childCat.smallImageUrl"
              background-color="#fff"
              :alt="childCat.name"
              :src="childCat.smallImageUrl"
              :width="200"
              :height="100"
              center-image
              image-params="w_200,h_110"
            />
            <image-placeholder v-else class="categoryNav__contentBannerImage" />
          </div>
          <div ref="subcatListParentText" class="categoriesWithListGrid__tileText">
            <h3 class="categoriesWithListGrid__tileTitle">
              <nuxt-link
                :to="
                  localePath({
                    name: 'category-slug',
                    params: { slug: childCat.slug },
                  })
                "
                class="categoriesWithListGrid__tileCatLink"
              >
                {{ childCat.name }}
              </nuxt-link>
            </h3>
          </div>
        </info-small-tile>
      </div>
    </div>
  </div>
</template>

<script>
import InfoSmallTile from '~/components/InfoSmallTile';
import NewImageBox from '@/components/NewImageBox';
import ImagePlaceholder from '~/components/ImagePlaceholder';

export default {
  name: 'CategoriesWithListGrid',
  components: { InfoSmallTile, NewImageBox, ImagePlaceholder },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.categoriesWithListGrid {
  $root: &;
  position: relative;
  margin-bottom: 3rem;
  background: $cWhite;
  z-index: 4;
  width: 100%;

  &__inner {
    position: relative;
  }

  &__items {
    display: flex;
    flex-wrap: wrap;
    border-style: solid;
    border-color: $cAddLight;
  }

  &__itemsItem {
    height: auto;
    cursor: pointer;
    margin: 0 -1px -1px 0;
    border: 1px solid #e1e1e1;
    position: relative;
    overflow: hidden;
    padding: 2rem;
    flex: 0 0 20%;
    max-width: 20%;
    transition: opacity $tr;

    @include rwd('large-tablet') {
      flex: 0 0 25%;
      max-width: 25%;
    }

    @include rwd('tablet') {
      flex: 0 0 33.333%;
      max-width: 33.333%;
    }

    @include rwd('small-tablet') {
      flex: 0 0 50%;
      max-width: 50%;
    }

    @include rwd('large-phone') {
      flex: 0 0 100%;
      max-width: 100%;
    }

    @include rwd('large-tablet', true) {
      &:hover {
        overflow: visible;

        #{$root}__tileImageWrapper {
          opacity: 0.7;
        }

        #{$root}__tileSubcats {
          opacity: 1;
          z-index: 1000;
        }

        #{$root}__tileSubcat {
          transform: translateY(0);
        }
      }
    }

    @include rwd('tablet') {
      min-height: 16rem;
    }
  }

  &__tileWrapperLink {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
  }

  &__tileImageWrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 11rem;
    margin-bottom: 1.5rem;
    width: 100%;
    transition: opacity $tr;

    @include rwd('small-tablet') {
      align-items: center;
    }
  }

  &__tileImage {
    max-height: 11rem;
    max-width: 100%;

    @include rwd('large-phone') {
      max-height: 8rem;
      max-width: 7rem;
    }
  }

  &__tileText {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;
  }

  &__tileTitle {
    text-align: center;
    max-width: 85%;
  }

  &__tileCatLink {
    color: $cMainDark;
    font-size: 2rem;
    line-height: 2.7rem;

    @include rwd('tablet') {
      font-size: 1.8rem;
      line-height: 2.2rem;
    }
  }

  &__tileSubtitle {
    color: $cMainLight;
    font-size: 1.6rem;
    line-height: 2rem;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  &__tileSubcats {
    transform: translateY(100%);
    opacity: 0;
    background: $cWhite;
    border: 0.5px solid $cAddLight;
    border-top: 0;
    width: calc(100% + 2px);
    bottom: 0;
    position: absolute;
    padding: 0 2rem 2rem;
    transition: opacity $tr, transform $tr;

    @include rwd('large-laptop') {
      bottom: 4px;
    }
  }

  &__tileSubcat {
    color: $cMainLight;
    text-align: center;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 0.5rem;
    transform: translateY(-50%);
    transition: transform $trM;
  }

  &__tileSubcatLink {
    display: block;
    transition: color $tr;
    &:hover {
      color: $cSec;
    }
  }
}
</style>
